export default "__VITE_ASSET__CJogNYFJ__"